import React, { useEffect, useMemo, useState } from 'react';
import { listenAssignments, fetchSchoolCalendar } from './api';
import { attendanceStats } from './reporting';

// The NJ-relevant instructional-days/hours record — ported from school-
// site's original AttendancePage.tsx. A day "counts" if every isFloor item
// scheduled for it is complete. Purely computed from assignments already in
// hand, no new writes — she's already doing this arithmetic by hand in her
// plan's header (180 days / 832 hours / NJ: no filing), which is why this
// was un-deferred.
export default function AttendanceTab({ familyData, student }) {
  const [assignments, setAssignments] = useState(null);
  const [calendar, setCalendar] = useState(undefined);

  useEffect(() => {
    if (!familyData?.id || !student?.studentEmail) return;
    const unsub = listenAssignments(familyData.id, student.studentEmail, setAssignments);
    fetchSchoolCalendar(familyData.id).then(setCalendar);
    return unsub;
  }, [familyData?.id, student?.studentEmail]);

  const stats = useMemo(
    () => (calendar?.weeks?.length && assignments ? attendanceStats(assignments, calendar) : null),
    [assignments, calendar]
  );

  if (assignments === null || calendar === undefined) return <p className="settings-note">Loading…</p>;
  if (!stats) return <p className="settings-note">No school calendar seeded yet.</p>;

  return (
    <div>
      <div style={{ display: 'flex', gap: 16, margin: '12px 0', flexWrap: 'wrap' }}>
        <div>
          <div style={{ fontSize: 28, fontWeight: 700 }}>{stats.totalCounted}/{calendar.totalInstructionalDays}</div>
          <div className="settings-note" style={{ margin: 0 }}>Instructional days logged</div>
        </div>
        <div>
          <div style={{ fontSize: 28, fontWeight: 700 }}>{stats.totalHours.toFixed(0)}</div>
          <div className="settings-note" style={{ margin: 0 }}>Hours logged (all courses + anchors)</div>
        </div>
      </div>
      <p className="settings-note">
        New Jersey doesn't require a minimum, so this isn't compliance — it's the honest record,
        worth keeping privately rather than filed anywhere.
      </p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(90px, 1fr))', gap: 6, marginTop: 12 }}>
        {stats.weeks.map(w => (
          <div key={w.weekNumber} style={{
            padding: 8, borderRadius: 6, textAlign: 'center', fontSize: 12,
            background: w.scheduled > 0 && w.counted === w.scheduled ? 'var(--good)' : 'var(--line)',
            color: w.scheduled > 0 && w.counted === w.scheduled ? '#fff' : 'inherit',
          }}>
            <div>Wk {w.weekNumber}</div>
            <div>{w.counted}/{w.scheduled}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
